import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BasicTooltip, palette } from '@livable/saas-react-components';
import { TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAllocationUtilityStyles from '../styles';
const SummaryTable = _ref => {
  var _residentSummaryEntri;
  let isExcluded = _ref.isExcluded,
    residentSummaryEntries = _ref.residentSummaryEntries;
  const classes = useAllocationUtilityStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const notSet = t('allocations.not_set');
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const utilities = residentSummaryEntries ? (_residentSummaryEntri = residentSummaryEntries[0]) === null || _residentSummaryEntri === void 0 ? void 0 : _residentSummaryEntri.utilitySummaryEntries.map(entry => entry.utilityTypeName) : [];
  const isFinancial = (dollarSign, parameter) => dollarSign ? "$".concat(parameter.toFixed(2)) : parameter;
  const renderCell = _ref2 => {
    let dollarSign = _ref2.dollarSign,
      parameter = _ref2.parameter;
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(isExcluded && classes.absorbCell)
    }, parameter == null ? notSet : isFinancial(dollarSign, parameter));
  };
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(isExcluded && classes.absorbCell, " ").concat(rightAlign && classes.rightAlign)
  }, text);
  const renderCellTooltip = (parameter, left) => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, /*#__PURE__*/React.createElement(Typography, {
    className: "".concat(classes.overflowCell, "  ").concat(isExcluded && classes.absorbCell),
    variant: "body1"
  }, parameter))));
  const columns = [{
    align: 'left',
    field: 'unitName',
    flex: 1,
    maxWidth: 150,
    headerName: t('corrections.unit_name'),
    renderCell: params => renderCellTooltip(params.row.unitName, true),
    renderHeader: () => renderHeader(t('corrections.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref3;
      return (_ref3 = '' + v1) === null || _ref3 === void 0 ? void 0 : _ref3.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'left',
    flex: 1,
    field: 'fullname',
    headerName: t('corrections.resident_name'),
    minWidth: 150,
    renderCell: params => renderCellTooltip(params.row.fullname),
    renderHeader: () => renderHeader(t('corrections.resident_name'))
  }];
  utilities === null || utilities === void 0 || utilities.forEach(utility => {
    columns.push({
      align: 'right',
      flex: 1,
      field: utility,
      headerAlign: 'right',
      headerName: utility,
      renderCell: params => {
        const residentSummary = residentSummaryEntries.find(entry => entry.fullname === params.row.fullname);
        const summary = residentSummary === null || residentSummary === void 0 ? void 0 : residentSummary.utilitySummaryEntries.find(entry => entry.utilityTypeName === utility);
        return /*#__PURE__*/React.createElement("div", {
          className: classes.cellContentWithTooltip
        }, /*#__PURE__*/React.createElement(Typography, {
          className: "".concat(isExcluded && classes.absorbCell),
          variant: "body1"
        }, "$", summary.amount.toFixed(2)));
      },
      renderHeader: () => renderHeader(utility, true)
    });
  });

  // columns.push({
  //   align: 'right',
  //   flex: 1,
  //   field: 'utilityCap',
  //   headerAlign: 'right',
  //   headerName: 'Statement cap credit',
  //   renderCell: params => renderCell({ dollarSign: true, parameter: params.row.utilityCap }),
  //   renderHeader: () => renderHeader('Statement cap credit'),
  // });

  columns.push({
    align: 'right',
    flex: 1,
    field: 'totalAmount',
    headerAlign: 'right',
    headerClassName: () => isExcluded ? '' : 'total_amount-header',
    headerName: t('corrections.total_amount'),
    renderCell: params => renderCell({
      dollarSign: true,
      parameter: params.row.totalAmount
    }),
    renderHeader: () => renderHeader(t('corrections.total_amount'))
  });
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      '& .total_amount-header': {
        backgroundColor: palette.shades[200],
        borderBottom: "1px solid ".concat(palette.shades[300])
      },
      [".".concat(gridClasses.cell, ".total_amount")]: {
        backgroundColor: palette.shades[200]
      }
    }
  }, /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    columnHeaderHeight: 95,
    columns: columns,
    disableRowSelectionOnClick: true,
    getCellClassName: params => {
      if (!isExcluded && params.field === 'totalAmount') return 'total_amount';
    },
    getRowClassName: () => classes.row,
    getRowId: row => row.residencyId,
    hideFooterSelectedRowCount: true,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pageSize: pageSize,
    pagination: true,
    rowHeight: 77,
    rows: residentSummaryEntries ? residentSummaryEntries : [],
    rowsPerPageOptions: [5, 10, 20],
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    slots: {
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '508-allocation-utility'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      })),
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null)
    }
  }));
};
export default SummaryTable;